import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import $ from "jquery";
import moment from "moment";
import DatePicker from "react-datepicker";
import CreateHelper from "../../../createHelper";
import TreeHelper from "../../../universe/CustomTreeTable.helper";
import "./table.scss";
import "../../../../Create/universe/CustomTreeTable.styles.scss";

const regex = /([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\:\&\s])/g;

class Table extends Component {
  state = {
    modifiedData: [],
    resetOnChangeInput: false,
    allocationSumError: false,
    allocationSum: null,
    allocationSumErrorDate: null,
    checkBoxSelectedList: [],
    listOfSumErrorDates: [],
  };

  componentDidMount() {
    const { portfolio } = this.props;
    if (portfolio.length > 0) {
      let modifiedData = TreeHelper.DataModify(portfolio);
      this.setState({
        modifiedData,
      });

      //100% validation
      this.newValidate(portfolio);
    }

    // jquery function goes here
    $("#mytable").on("click", ".toggle", function () {
      //Gets all <tr>'s  of greater depth
      //below element in the table
      var findChildren = function (tr) {
        var depth = tr.data("depth");
        return tr.nextUntil(
          $("tr").filter(function () {
            return $(this).data("depth") <= depth;
          })
        );
      };

      var el = $(this);
      var tr = el.closest("tr"); //Get <tr> parent of toggle button
      var children = findChildren(tr);

      //Remove already collapsed nodes from children so that we don't
      //make them visible.
      //(Confused? Remove this code and close Item 2, close Item 1
      //then open Item 1 again, then you will understand)
      var subnodes = children.filter(".expand");
      subnodes.each(function () {
        var subnode = $(this);
        var subnodeChildren = findChildren(subnode);
        children = children.not(subnodeChildren);
      });

      //Change icon and hide/show children
      if (tr.hasClass("collapse-table")) {
        tr.removeClass("collapse-table").addClass("expand");
        children.hide();
        el.removeClass("fa-minus-square").addClass("fa-plus-square");
      } else {
        tr.removeClass("expand").addClass("collapse-table");
        children.show();
        el.removeClass("fa-plus-square").addClass("fa-minus-square");
      }
      return children;
    });
    // collapsing only cash row
    setTimeout(
      () => ($("#CASH").length > 0 ? $("#CASH .toggle").click() : null),
      0
    );
  }

  componentWillReceiveProps(nextProps) {
    const { portfolio } = nextProps;
    if (portfolio.length > 0) {
      let modifiedData = TreeHelper.DataModify(portfolio);
      this.setState({
        modifiedData,
      });

      //100% validation
      this.newValidate(portfolio);
    }
  }

  // 100% validation function
  newValidate = (portfolio) => {
    const { setAllocatioError } = this.props;
    var sum = CreateHelper.ADD(portfolio);

    const ADD = (array) => {
      let sum;
      sum = array.reduce((p, c) => p + c * 1, 0);
      return sum;
    };

    // validation based on individual date 100%
    // getting individual date and list of values
    let groups = {};
    for (let i = 0; i < portfolio.length; i++) {
      let groupName = portfolio[i]["date"];

      if (!groups[groupName]) {
        groups[groupName] = [];
      }
      groups[groupName].push(portfolio[i].val);
    }
    let arrayOFSum = [];
    for (let groupName in groups) {
      arrayOFSum.push({ date: groupName, sum: ADD(groups[groupName]) });
    }

    for (let i = 0; i < arrayOFSum.length; i++) {
      let sum = arrayOFSum[i]["sum"];
      let dt = new Date(arrayOFSum[i]["date"]);
      let date = moment(dt).format("MM/DD/YYYY");

      if (sum === 100) {
        this.setState({
          allocationSumError: false,
          allocationSum: null,
          allocationSumErrorDate: null,
        });
        setAllocatioError(false);
      } else if (sum !== 100) {
        this.setState({
          allocationSumError: true,
          allocationSum: sum,
          allocationSumErrorDate: date,
        });
        setAllocatioError(true);
        break;
      }
    }
    // pushing dates to error list in state
    let listOfSumErrorDates = [];

    for (let i = 0; i < arrayOFSum.length; i++) {
      let sum = arrayOFSum[i]["sum"];
      let dt = new Date(arrayOFSum[i]["date"]);
      let date = moment(dt).format("MM/DD/YYYY");

      if (sum !== 100) {
        listOfSumErrorDates.push(date);
      }
    }
    this.setState({
      listOfSumErrorDates,
    });
    // if (sum === 100) {
    //   setAllocatioError(false);
    //   this.setState({
    //     allocationSumError: false,
    //     allocationSum: null,
    //   });
    //   console.log("count is 100%");
    //   return;
    // } else {
    //   setAllocatioError(true);
    //   console.log("count is not 100%");
    //   this.setState({
    //     allocationSumError: true,
    //     allocationSum: sum,
    //   });
    //   return;
    // }
  };
  innerContent = (data) => {
    const { portfolio } = this.props;

    let name = Object.keys(data)[0];
    let innerList = Object.keys(data[name]);

    const inputFieldHandler = (e) => {
      const { changeHandle } = this.props;
      let index = e.target.getAttribute("index") * 1;
      let { value } = e.target;
      changeHandle(index, "val", value);

      // setting value to re render table
      this.setState({ resetOnChangeInput: true });
      setTimeout(() => this.setState({ resetOnChangeInput: false }), 400);
      // this.maxAllocation(value, index);
      this.newValidate(portfolio);
    };

    const dateHandler = (date, index) => {
      this.props.changeHandle(index, "date", date);

      const { portfolio } = this.props;
      if (portfolio.length > 0) {
        let modifiedData = TreeHelper.DataModify(portfolio);
        this.setState({
          modifiedData,
        });
      }
      this.setState({ resetOnChangeInput: true });
      setTimeout(() => this.setState({ resetOnChangeInput: false }), 400);
      setTimeout(() => this.newValidate(portfolio), 400);
    };
    const checkBoxHandler = (e) => {
      // let index = e.target.getAttribute("index") * 1;
      let status = e.target.checked;
      let symbol = e.target.getAttribute("data-symbol");

      if (status) {
        this.setState({
          checkBoxSelectedList: [...this.state.checkBoxSelectedList, symbol],
        });
      } else {
        this.setState({
          checkBoxSelectedList: this.state.checkBoxSelectedList.filter(
            (item) => item !== symbol
          ),
        });
      }
    };

    const coreAllocationCounter = (type, name, type2, name2) => {
      let Data;

      if (type2 && name2) {
        Data = portfolio.filter((e) => e[type2] == name2);
      } else {
        Data = portfolio;
      }

      let value = Data.filter((e) => e[type] == name).map((el) =>
        el.val == null ? 0 : el.val * 1
      );

      let reduced_val = value.length > 0 ? value.reduce((a, b) => a + b) : 0;

      return reduced_val == 0 ? "" : reduced_val;
    };
    return (
      <Fragment key={`${name}`}>
            {/*}
        <tr
          data-depth="0"
          className="collapse-table level0"
          style={{ height: "2px" }}
        >
          <td className="td-depth-0" id={name.toUpperCase()}>
            <i className="toggle fa fa-minus-square" aria-hidden="true"></i>
            {name}
          </td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>
            <input
              type="text"
              value={coreAllocationCounter("fund_asset_class_focus", name)}
              disabled
              className="ip-field"
              style={{ backgroundColor: "#eee" }}
            />
          </td>
        </tr>*/}
        {innerList.map((element, i) => (
          <Fragment key={`key-${element}-${i}`}>
                    {/*<tr data-depth={1} className="collapse-table level1">
              <td className="td-depth-1">
                <i
                  className="cursor toggle fa fa-minus-square"
                  aria-hidden="true"
                ></i>
                {element}
              </td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>
                <input
                  type="text"
                  value={coreAllocationCounter("new_classification", element)}
                  disabled
                  className="ip-field"
                  style={{ backgroundColor: "#eee" }}
                />
              </td>
            </tr>*/}
            {data[name][element].map((d, i) => (
              <Fragment key={`${Object.keys(d)[0]}-${i}`}>
                            {/*<tr data-depth={2} className={`collapse-table level${2}`}>
                  <td className="td-depth-2">
                    <i
                      className="cursor toggle fa fa-minus-square"
                      aria-hidden="true"
                    ></i>
                    {Object.keys(d)[0]}
                  </td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>
                    <input
                      type="text"
                      value={coreAllocationCounter(
                        "new_style",
                        Object.keys(d)[0],
                        "new_classification",
                        element
                      )}
                      disabled
                      className="ip-field"
                      style={{ backgroundColor: "#eee" }}
                    />
                  </td>
                </tr>*/}

                {d[Object.keys(d)[0]].map(function (dl) {
                  return (
                    <tr
                      data-depth={3}
                      className={`collapse-table level${3}`}
                      key={`${dl.fund_name}-${dl.index}`}
                      id={`${dl.fund_name.replace(regex, "")}`}
                    >
                      <td className="td-depth-3" id={`row-${dl.index}`}>
                        <input
                          type="checkbox"
                          index={dl.index}
                          data-symbol={dl.symbol}
                          className="cursor"
                          style={{ marginRight: "10px" }}
                          onChange={(e) => checkBoxHandler(e)}
                        />
                        {dl.fund_name}
                      </td>
                      <td>
                        <DatePicker
                          closeOnScroll={true}
                          selected={dl.date}
                          placeholderText="mm-dd-yyyy"
                          onChange={(date) => dateHandler(date, dl.index)}
                        />
                      </td>
                      <td>{dl.symbol}</td>
                          {/*<td>{dl.exchange}</td>*/}
                      <td>&nbsp;</td>
                      <td>
                        <input
                          type="number"
                          min="0"
                          defaultValue={dl.val}
                          index={dl.index}
                          onChange={(e) => inputFieldHandler(e)}
                          className="ip-field"
                        />
                      </td>
                    </tr>
                  );
                })}
              </Fragment>
            ))}
          </Fragment>
        ))}
      </Fragment>
    );
  };
  clearButtonHandler = () => {
    const { removePortfolio } = this.props;
    const { checkBoxSelectedList } = this.state;
    removePortfolio(checkBoxSelectedList);

    //checking if error input field is deleted
    // setTimeout(() => this.maxAllocation(1, 0), 100);
    this.setState({
      checkBoxSelectedList: [],
    });
  };
  render() {
    const {
      modifiedData,
      resetOnChangeInput,
      allocationSumError,
      listOfSumErrorDates,
    } = this.state;
    const {
      portfolio,
      historical_returns,
      portfolioTableActive,
      toggleButtonHandler,
      historical_upload_error,
      historical_error_name,
      historical_data_empty,
    } = this.props;
    return (
      <Fragment>
        <div className="analyze_table">
          {allocationSumError ||
          historical_upload_error ||
          historical_data_empty ? (
            <div className="analyze_table_warning">
              {historical_data_empty ? (
                <span className="dataWarning ml mb">
                  Returns table uploaded is empty. Please populate historical
                  returns by date and re-upload.
                </span>
              ) : null}
              <Fragment>
                {historical_upload_error ? (
                  <span className="dataWarning ml mb">
                    {`${historical_error_name.toUpperCase()} column missing. Please make sure "${historical_error_name}" column exists in the uploaded historical returns
                excel.`}
                  </span>
                ) : null}
              </Fragment>

              <Fragment>
                {allocationSumError ? (
                  <span className="dataWarning ml flex-wrap">
                    {/* {allocationSum}% */}
                    For &nbsp;
                    {listOfSumErrorDates.map((e, i) => (
                      <Fragment key={`date_${i}`}>
                        <span key={i}>{e}</span>
                        {listOfSumErrorDates.length - 1 !== i ? "," : null}
                      </Fragment>
                    ))}
                    &nbsp;Allocations are not adding upto 100%. Please fix and
                    re-upload.
                  </span>
                ) : null}
              </Fragment>
            </div>
          ) : null}
          {historical_returns.length > 0 ? (
            <div className="analyze_returns_btn">
              <button
                className={
                  portfolioTableActive ? "analyze_returns_btn_active" : null
                }
                onClick={() => toggleButtonHandler(true)}
              >
                Portfolio
              </button>
              <button
                className={
                  !portfolioTableActive ? "analyze_returns_btn_active" : null
                }
                onClick={() => toggleButtonHandler(false)}
              >
                Returns
              </button>
            </div>
          ) : null}
          <div className="analyze_table__table">
            <table
              id="mytable"
              className={`${portfolio.length < 10 ? "mb-100" : "mb-10"}`}
            >
              <thead>
                <tr>
                  <th className="sticky pl-30">
                    SECURITY
                  </th>
                  <th className="sticky">Date</th>
                  <th className="sticky wd-200">SYMBOL</th>
                  <th className="sticky">&nbsp;</th>
                  <th className="sticky">CORE ALLOCATION(%)</th>
                </tr>
              </thead>
              {portfolio.length > 0 ? (
                <tbody>
                  {modifiedData.length ||
                  (modifiedData.length && resetOnChangeInput)
                    ? modifiedData.map((element) => {
                        return this.innerContent(element);
                      })
                    : null}
                </tbody>
              ) : null}
            </table>
          </div>
        </div>
        {portfolio.length > 0 ? (
          <div>
            <button className="btn" onClick={() => this.clearButtonHandler()}>
              Remove
            </button>
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default connect(
  ({
    create: {
      steps: {
        universeLite: { portfolio, historical_returns },
      },
    },
  }) => ({
    portfolio,
    historical_returns,
  }),
  (dispatch) => ({
    setAllocatioError: (value) =>
      dispatch({
        type: "ALLOCATION_SUM_ERROR",
        payload: value,
      }),
    changeHandle: (i, key, value) =>
      dispatch({
        type: "SET_UNIVERSE_LITE_SYMBOL_VALUE",
        payload: { i, key, value },
      }),
    removePortfolio: (payload) =>
      dispatch({
        type: "DELETE_UNIVERSE_LITE_DATA",
        payload,
      }),
  })
)(Table);



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/Analyze/table/table.jsx